import React, { Suspense, useEffect, useState } from 'react';
import useUserStore from '@core/stores/useUserStore';
import { devGroup } from '../../../tenantConfig';

const DebugPanel = React.lazy(() => import('./DebugPanel'));

/**
 * Dynamically loads the `DebugPanel` component only if the user's `buGroup` matches the `devGroup`.
 * This component ensures that only users with the correct `buGroup` have access to the debug panel.
 *
 * @returns  Returns a dynamically loaded `DebugPanel` if the user has access, otherwise `null`.
 */
const GuardComponent = () => {
    const buGroup = useUserStore((state) => state.buGroup);
    const [canRender, setCanRender] = useState(false);

    useEffect(() => {
        setCanRender(buGroup === devGroup);
    }, [buGroup]);

    return (
        canRender && (
            <Suspense>
                <DebugPanel />
            </Suspense>
        )
    );
};

export default GuardComponent;
